import { asyncAction } from 'lib/actionCreators'

export const candidateAssignedJobs = asyncAction('candidate/DASHBOARD_ASSIGNED_JOBS')
export const candidateAppliedJobs = asyncAction('candidate/DASHBOARD_APPLIED_JOBS')
export const getInvitedCandidates = asyncAction('candidate/DASHBOARD_INVITED_CANDIDATES')
export const getPendingCandidates = asyncAction('candidate/DASHBOARD_PENDIDNG_CANDIDATES')
